import { getForumAPIPath } from './api'
import { BASE_URL } from '@/config'

export const PAGES_SEPARATOR = '/pages/'

export const getProjectHref = (ownerName: string, publicProjectName: string): string => {
  return `/${ownerName}/${publicProjectName}/`
}

export const getTagHref = (tag: string): string => {
  return `/tags/${encodeURIComponent(tag)}/`
}

export const getTagExternalUrl = (tag: string): string => {
  return getUrl(`/projects${getTagHref(tag)}`)
}

export const getProjectExternalUrl = (ownerName: string, publicProjectName: string): string => {
  return getUrl(`/projects${getProjectHref(ownerName, publicProjectName)}`)
}

export const getUserHref = (userName: string): string => {
  return `/${userName}/`
}

export const getWorkbenchHref = (projectIdExt: string): string => {
  return getWorkbenchUrl(`/?pid=${projectIdExt}`)
}

export const getProjectCopyHref = (projectIdExt: string): string => {
  return getDashboardUrl(`/projects/${projectIdExt}/copy/`)
}

export const getProjectShareHref = (projectIdExt: string): string => {
  return getDashboardUrl(`/projects/${projectIdExt}/share/`)
}

export const getProjectEditHref = (projectIdExt: string): string => {
  return getDashboardUrl(`/projects/${projectIdExt}/edit/`)
}

export const getProjectDeleteHref = (projectIdExt: string): string => {
  return getDashboardUrl(`/projects/${projectIdExt}/delete/`)
}

export const getWorkbenchUrl = (path: string): string => {
  if (path.startsWith('/')) {
    path = path.slice(1)
  }
  return `${BASE_URL}/workbench/${path}`
}

export const getDashboardUrl = (path: string): string => {
  if (path.startsWith('/')) {
    path = path.slice(1)
  }
  return `${BASE_URL}/dashboard/${path}`
}

export const getUrl = (path: string): string => {
  return `${BASE_URL}${path}`
}

export const getForumTopicUrl = (topicSlug: string, topicId: number): string => {
  return getForumAPIPath(`/t/${topicSlug}/${topicId}/`, false)
}

export const getForumPostUrl = (topicSlug: string, topicId: number, postId: number): string => {
  return getForumAPIPath(`/t/${topicSlug}/${topicId}/${postId}/`, false)
}

export const getForumUserUrl = (userName: string): string => {
  return getForumAPIPath(`/u/${userName}/`, false)
}

export const getForumUserActivityUrl = (userName: string): string => {
  return getForumUserUrl(userName) + 'activity/'
}

export const getWebMenuUrl = (path: string): string => {
  const defaultInternalPrefix = 'https://www.simscale.com'
  const isExternalPath = path.startsWith('https://') && !path.includes(defaultInternalPrefix)
  return isExternalPath ? path : getUrl(path.replace(defaultInternalPrefix, ''))
}

export const waitFor = (milliseconds: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, milliseconds))
